import Footer from '@/components/ui/Footer';
import Flex from '@/components/ui/Flex';
import BuyButton from '@/components/PurchasePage/OrderSummary/BuyButton';
import { useTotals } from '@/hooks/useTotals';

export default function OrderSummaryFooter() {
  const totals = useTotals();
  return (
    <Footer height="112px">
      <Flex.Col gap="2" className="justify-end w-full h-full">
        <Flex.Row className="justify-between text-xl font-bold">
          <span>Total</span>
          <Flex.Row gap="2">
            {totals.isDiscounted && (
              <div className="text-muted line-through">
                <span className="font-normal">{totals.subtotalPriceText}</span>
              </div>
            )}
            <div>{totals.totalPriceText} </div>
          </Flex.Row>
        </Flex.Row>
        <BuyButton />
      </Flex.Col>
    </Footer>
  );
}
